var ko = require('knockout');

ko.components.register('register-continue-button', {
  viewModel: require('./register-continue-button'),
  template: require('./register-continue-button.template')
});

$('[data-register-continue-button]').each(function() {
  ko.applyBindings({}, this);
});
